import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, createBrowserRouter } from 'react-router';

import { ProtectedRoute } from '@/components/protected-route';
import { ROUTE_AUDIT_CASES, ROUTE_HOME, ROUTE_SUPPLIERS } from '@/constants/router';

import { Audit, Dashboard, Error, Home } from '../routes';
import { auditLoader } from '../routes/audit/loader';
import { dashboardLoader } from '../routes/dashboard/loader';
import { homeLoader } from '../routes/home/loader';
import { rootLoader } from '../routes/home/root-loader';

export const router = createBrowserRouter([
  {
    path: ROUTE_HOME,
    loader: rootLoader,
    // NOTE: we don't want to show anything when the app is hydrating, solution below is to avoid a warning:
    // No `HydrateFallback` element provided to render during initial hydration overrideMethod
    HydrateFallback: () => <></>,
    element: (
      <ErrorBoundary
        fallbackRender={({ error, resetErrorBoundary }) => (
          <Error error={error} onReset={resetErrorBoundary} />
        )}
      >
        <main>
          <Outlet />
        </main>
      </ErrorBoundary>
    ),
    errorElement: <Error />,
    children: [
      {
        index: true,
        loader: homeLoader,
        element: <Home />,
      },
      {
        element: (
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        ),
        children: [
          {
            path: ROUTE_SUPPLIERS,
            children: [
              {
                path: ':supplier_id',
                children: [
                  {
                    path: 'audit-cases-dashboard',
                    loader: dashboardLoader,
                    element: <Dashboard />,
                  },
                ],
              },
            ],
          },
          {
            path: ROUTE_AUDIT_CASES,
            children: [
              {
                path: ':audit_case_uuid',
                loader: ({ params }) => auditLoader(params.audit_case_uuid || ''),
                shouldRevalidate: ({ currentUrl, nextUrl, defaultShouldRevalidate }) =>
                  currentUrl.pathname === nextUrl.pathname && currentUrl.search === nextUrl.search
                    ? false
                    : defaultShouldRevalidate,
                element: <Audit />,
              },
            ],
          },
        ],
      },
    ],
  },
]);
